let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ibfKG")).then(() => parcelRequire('kbvg1'));